import React, { useState } from 'react';
import styles from '../../styles/Roommates/GroupChat.module.css';


const NewMessageInput = ({ onSend }) => {
  const [content, setContent] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (content.trim() !== "") {
      onSend(content);
      setContent("");
    }
  };

  return (
    <form onSubmit={handleSubmit} className={styles.newMessageForm}>
      <input
        type="text"
        placeholder="Send a message..."
        value={content}
        onChange={(e) => setContent(e.target.value)}
        className={styles.messageInput}
      />
      <button type="submit" className={styles.sendButton}>Send</button>
    </form>
  );
};

export default NewMessageInput;
